import { useEffect, useState } from "react";
import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import './JobCategory.css';
import {
    Grid,
    GridColumn,
    GridDataStateChangeEvent,
} from "@progress/kendo-react-grid";
import { ColumnMenuDefaultFilter } from "../Shared/Components/ColumnMenuFilter";
import { useNavigate } from "react-router-dom";
import JobCategoryService from "../Shared/Services/JobCategoryService";
import SweetAlertService from "../../../services/SweetAlertService";
import { DeletePopupConfirmationMessage } from "../Shared/Constants/AdminModuleConstants";

export const JobCategoryList = () => {
    let initialState = { dataState: { skip: 0, take: 20 }, result: { data: [], total: 0 } };
    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);

    useEffect(() => {
        fetchData(dataState);
    }, []);

    const fetchData = (state: State) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        JobCategoryService.getAll(queryStr)
            .then((response) => {
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState);
    };

    const navigate = useNavigate();

    const onDelete = (id: any) => {
        SweetAlertService.confirm('Delete', DeletePopupConfirmationMessage).then((res) => {
            if (res.isConfirmed) {
                JobCategoryService.deleteJobCategory(id).then((res) => {
                    if (res) {
                        fetchData(dataState);
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        })
    }

    const renderLinkCell = (props: any) => {
        const { dataItem } = props;
        return (
            <td className="name-as-link">
                <a onClick={() => navigate(`/jobsubcategory/${dataItem.id}`)}>{dataItem.name}</a>
            </td>
        );
    };

    const renderActionCell = (props: any) => {
        return (
            <td>
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/updatejobcategory/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-edit k-icon-color"></span>
                </a>
                <a className="btn btn-primary btn-sm ms-1" onClick={() => navigate(`/viewjobcategory/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-information k-icon-color"></span>
                </a>
                <a className="btn btn-primary btn-sm ms-1" onClick={() => onDelete(props.dataItem.id)}>
                    <span className="k-icon k-i-delete k-icon-color"></span>
                </a>
            </td>
        );
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Job Categories
                    <button
                        title="New Job category"
                        className="btn btn-primary pull-right"
                        onClick={() => navigate('/createjobcategory')}>
                        New Job category
                    </button>
                </h4>
            </div>
            <div className="card-body card-body-custom">
                <Grid
                    sortable={true}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 10, 15, 20],
                    }}
                    {...dataState}
                    data={result}
                    onDataStateChange={dataStateChange}>
                    <GridColumn field="name" cell={renderLinkCell} title="Name" columnMenu={ColumnMenuDefaultFilter} width="202px" />
                    <GridColumn field="shortName" title="ShortName" columnMenu={ColumnMenuDefaultFilter} width="202px" />
                    <GridColumn field="isCountToSession" filter="boolean" title="Count To Sessions" columnMenu={ColumnMenuDefaultFilter} width="202px" />
                    <GridColumn field="isDefaultInWorkActivity" filter="boolean" title="Default In WorkActivity" columnMenu={ColumnMenuDefaultFilter} width="240px" />
                    <GridColumn field="assignedSubRoleNames" title="Assigned Roles" columnMenu={ColumnMenuDefaultFilter} width="234px" />
                    <GridColumn title="Action" cell={renderActionCell} width="160px" />
                </Grid>
            </div>
        </div>
    )
}